namespace Solovis.UI.Colors {

    export function rgbToHex(r: number, g: number, b: number): string {

        var componentToHex = function (c) {
            var hex = c.toString(16);
            return hex.length == 1 ? "0" + hex : hex;
        }

        return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
    }

    export function hexToRgb(hex: string): { r: number, g: number, b: number } {
        // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
        var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
        hex = hex.replace(shorthandRegex, function (m, r, g, b) {
            return r + r + g + g + b + b;
        });

        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ?
            {
                r: parseInt(result[1], 16),
                g: parseInt(result[2], 16),
                b: parseInt(result[3], 16)
            } :
            null;
    }

    // Any changes to Colors.less should also be made here
    export var _palette = {
        brand: "#00a9e0",
        brand_dark: "#006f93",
        brand_darker: "#00516b",
        brand_darkest: "#003647",
        brand_light: "#2eccff",
        brand_lighter: "#7adeff",
        brand_lightest: "#c6f1ff",
        gray: "#95a5a6",
        gray_dark: "#7b8a8b",
        gray_darker: "#222222",
        gray_darkest: "#0d0d0d",
        gray_light: "#dddddd",
        gray_lighter: "#ecf0f1",
        gray_lightest: "#fafafa"
    }

    export function getHexValue(colorName: string): string {
        var hex = Colors._palette[colorName];
        return hex;
    }

}